const LOCALHOST_FALLBACK = "http://localhost:8000";

function isLocalHost(hostname: string): boolean {
	return (
		hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1"
	);
}

export function getBackendBaseUrl(): string {
	const rawEnv = import.meta.env.VITE_APP_BACKEND_BASE_URL;
	const envValue = typeof rawEnv === "string" ? rawEnv.trim() : "";
	if (envValue) {
		return envValue;
	}

	if (typeof window === "undefined") {
		return "";
	}

	const { protocol, hostname } = window.location;

	if (isLocalHost(hostname)) {
		if (import.meta.env.DEV) {
			console.warn(
				"VITE_APP_BACKEND_BASE_URL is missing; using localhost fallback.",
			);
		}
		return LOCALHOST_FALLBACK;
	}

	const apiHostname = hostname.startsWith("api.")
		? hostname
		: `api.${hostname}`;
	return `${protocol}//${apiHostname}`;
}
